export const Roles = {
  ADMIN: 'ADMIN',
  CLIENT_ADMIN: 'CLIENT_ADMIN',
  AUDITOR: 'AUDITOR',
};
